/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, ScrollView, Dimensions } from 'react-native';
import Toast from 'react-native-toast-message';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { isWeb } from '@global/screens';
import { convertFullAddress, convertTimeOfDate } from '@global/helpers';
import Colors from '@global/colors';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import DatePicker from '@components/form/DatePicker';
import TimePicker from '@components/form/TimePicker';
import Input from '@components/form/Input';
import SociollaText from '@components/sociolla/SociollaText';
import Alert from '@components/global/Alert';
import * as Layout from '@components/screen/Layout';
import MapPicker from '@components/form/MapPicker';

import { MsB2b } from '@api/ms-b2b';
import { showAlert } from '@/store/global';
import { showPopup } from '@/store/modal';

const dimension = Dimensions.get('screen');
const today = new Date();
const now_time = `${today.getHours()}:${today.getMinutes()}`;

const Reschedule = ({ detailData = {}, show, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const userRole = userData?.role?.code;
  const isSalesman = userRole == 'salesman' ? true : false;

  const FormValidationSchema = Yup.object().shape({
    date: Yup.string().required('Date is required.'),
    start_time: Yup.string().required('Time from is required.'),
    end_time: Yup.string().required('Time to is required.'),
    notes: Yup.string(),
  });
  const formRef = useRef();

  const dateChange = (value) => {
    formRef.current.setFieldValue('date', value);
    formRef.current.setFieldValue('start_time', '');
    formRef.current.setFieldValue('end_time', '');
  };

  const disabledStartTime = (value) => {
    if (value) {
      const startDate = new Date(value);
      if (startDate.getTime() > today.getTime()) {
        if (startDate.getDate() == new Date().getDate()) {
          return `${startDate.getHours()}:${startDate.getMinutes()}`;
        } else {
          return false;
        }
      }
    }
    return now_time;
  };

  return (
    <ModalFull
      testID="sales-activity-reschedule-modal"
      title={
        detailData.customer && detailData.customer.name
          ? detailData.customer.name
          : '-'
      }
      show={show}
      back={isWeb ? false : true}
      onClose={() => onClose()}>
      <Formik
        innerRef={formRef}
        initialValues={{
          date: detailData?.visited_at ? detailData.visited_at : '',
          finished_at: detailData?.finished_at ? detailData.finished_at : '',
          start_time: detailData?.start_time ? detailData.start_time : '',
          end_time: detailData?.end_time ? detailData.end_time : '',
          notes: detailData?.notes ? detailData.notes : '',
        }}
        validationSchema={FormValidationSchema}
        onSubmit={async (values) => {
          dispatch(showPopup({ name: 'isLoading', value: true }));

          let status = 'waiting_confirmation';

          if (
            [
              'sales_supervisor',
              'branch_head',
              'regional_manager',
              'regional_support',
              'key_account_manager',
              'group_key_account_manager',
              'national_key_account_manager',
            ].includes(userRole)
          ) {
            status = 'approved';
          }

          const additional_description = isSalesman
            ? ', you`ll be notified once it has been approved'
            : '';

          try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const payload = {
              notes: values.notes ? values.notes : '',
              visited_at: values.date
                ? convertTimeOfDate(values.date, values.start_time, tz)
                : '',
              finished_at: values.date
                ? convertTimeOfDate(values.date, values.end_time, tz)
                : '',
              start_time: values.start_time ? values.start_time : '',
              end_time: values.end_time ? values.end_time : '',
              status: status,
            };
            const updateData = await MsB2b.updateSalesActivityStatus(
              detailData._id,
              status,
              payload,
            );
            if (updateData && updateData.data && updateData.data.data) {
              dispatch(showPopup({ name: 'isLoading', value: false }));
              dispatch(
                showAlert({
                  show: true,
                  isModal: true,
                  title: 'Reschedule Activity Plan Submitted',
                  description: `Reschedule activity plan submitted${additional_description}.`,
                  isConfirm: false,
                  testID: 'sales-activity-reschedule-submitted',
                  onCallback: () => {
                    onSubmit();
                  },
                }),
              );
            } else {
              dispatch(showPopup({ name: 'isLoading', value: false }));
              Toast.show({ text1: 'A system error occurred', type: 'error' });
            }
          } catch (error) {
            dispatch(showPopup({ name: 'isLoading', value: false }));
            Toast.show({
              text1:
                (error &&
                  error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                'A system error occurred',
              type: 'error',
            });
          }
        }}>
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          errors,
          touched,
          values,
        }) => (
          <ScrollView contentContainerStyle={{ width: '100%', padding: 15 }}>
            <Layout.Wrapper fullWidth>
              <Layout.FormWrapper>
                <View
                  style={{
                    width: '100%',
                    flexDirection: isWeb ? 'row' : 'column',
                    justifyContent: 'space-between',
                  }}>
                  <View
                    style={{
                      width: isWeb ? '50%' : '100%',
                      paddingRight: isWeb ? 15 : 0,
                      borderRightColor: isWeb ? Colors.grey0 : 'transparent',
                      borderRightWidth: 1,
                    }}>
                    <Layout.FormGroup>
                      <Input
                        label="Sales Person"
                        value={
                          detailData.user && detailData.user.name
                            ? detailData.user.name
                            : '-'
                        }
                        editable={false}
                      />
                    </Layout.FormGroup>
                    <Layout.FormGroup>
                      <Input
                        label="Customer"
                        value={
                          detailData.customer && detailData.customer.name
                            ? detailData.customer.name
                            : '-'
                        }
                        editable={false}
                      />
                    </Layout.FormGroup>
                    {detailData.activity_type ==
                    'visiting_existing_customer' ? (
                      <>
                        <Layout.FormGroup>
                          <Input
                            label="Customer Address"
                            value={
                              detailData.customer && detailData.customer.address
                                ? convertFullAddress(
                                    detailData.customer.address,
                                  )
                                : '-'
                            }
                            editable={false}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <View
                            style={{
                              width: '100%',
                              flexDirection: 'row',
                              marginTop: 15,
                            }}>
                            <SociollaText
                              style={{
                                minWidth: 50,
                                fontSize: 13,
                                color: Colors.blue0,
                              }}>
                              Detail :{' '}
                            </SociollaText>
                            <SociollaText style={{ fontSize: 13 }}>
                              {detailData.customer &&
                              detailData.customer.address
                                ? convertFullAddress(
                                    detailData.customer.address,
                                  )
                                : '-'}
                            </SociollaText>
                          </View>
                        </Layout.FormGroup>
                        {detailData.customer.address?.lat_long ? (
                          <Layout.FormGroup>
                            <View
                              style={{
                                width: '100%',
                                flexDirection: 'row',
                                marginTop: 15,
                              }}>
                              <MapPicker
                                value={detailData.customer.address.lat_long}
                                hideInput={true}
                                disabled={true}
                                editable={false}
                                containerStyle={{
                                  marginTop: 14,
                                  borderRadius: 4,
                                  width: '100%',
                                }}
                              />
                            </View>
                          </Layout.FormGroup>
                        ) : (
                          false
                        )}
                      </>
                    ) : (
                      false
                    )}
                  </View>
                  <View
                    style={{
                      width: isWeb ? '50%' : '100%',
                      paddingLeft: isWeb ? 15 : 0,
                    }}>
                    <Layout.FormGroup>
                      <DatePicker
                        testID="sales-activity-reschedule-date"
                        label="Date"
                        name="date"
                        value={values.date}
                        disablePastDates={true}
                        hasError={
                          errors.date && touched.date ? errors.date : null
                        }
                        onChange={(value) => dateChange(value)}
                      />
                    </Layout.FormGroup>
                    <Layout.FormGroup>
                      <SociollaText style={{ fontSize: 12 }}>Time</SociollaText>
                      <View
                        style={{
                          width: '100%',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}>
                        <View style={{ width: '48%' }}>
                          <TimePicker
                            testID="sales-activity-reschedule-time-from"
                            label="From"
                            value={values.start_time}
                            disableBeforeTime={values.end_time}
                            disableAfterTime={disabledStartTime(values.date)}
                            hasError={
                              errors.start_time && touched.start_time
                                ? errors.start_time
                                : null
                            }
                            onChange={(value) =>
                              setFieldValue('start_time', value)
                            }
                          />
                        </View>
                        <View style={{ width: '48%' }}>
                          <TimePicker
                            testID="sales-activity-reschedule-time-to"
                            label="To"
                            value={values.end_time}
                            disableAfterTime={
                              values.start_time
                                ? values.start_time
                                : values.date
                                ? new Date(values.date).getDate() !=
                                  today.getDate()
                                  ? false
                                  : now_time
                                : now_time
                            }
                            hasError={
                              errors.end_time && touched.end_time
                                ? errors.end_time
                                : null
                            }
                            onChange={(value) =>
                              setFieldValue('end_time', value)
                            }
                          />
                        </View>
                      </View>
                    </Layout.FormGroup>
                    <Layout.FormGroup>
                      <Input
                        testID="sales-activity-reschedule-notes"
                        label="Notes (Optional)"
                        value={values.notes}
                        multiline={true}
                        numberOfLines={4}
                        hasError={
                          errors.notes && touched.notes ? errors.notes : null
                        }
                        onChangeText={handleChange('notes')}
                      />
                    </Layout.FormGroup>
                  </View>
                </View>
              </Layout.FormWrapper>
              <View
                style={{
                  width: '100%',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingVertical: 15,
                }}>
                <Button
                  testID="sales-activity-reschedule-submit-btn"
                  rounded={true}
                  buttonStyle={{ width: isWeb ? 130 : dimension.width - 30 }}
                  title={
                    <SociollaText
                      type="bold"
                      style={{
                        fontSize: 14,
                        letterSpacing: 0.5,
                        color: Colors.white,
                      }}>
                      Reschedule
                    </SociollaText>
                  }
                  onPress={handleSubmit}
                />
              </View>
            </Layout.Wrapper>
          </ScrollView>
        )}
      </Formik>
      <Alert />
    </ModalFull>
  );
};

export default React.memo(Reschedule, (prev, next) => prev == next);
